var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDesktopLeftEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 638,
    viewBox: "0 0 269 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_8_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-134.897 462.687C-199.033 395.418 -121.284 199.08 -74.3926 109.32C33.56 111.717 -27.9824 136.01 0.926087 226.511C29.8345 317.013 112.7 304.983 151.507 370.291C190.314 435.598 68.9752 501.466 38.4192 516.866C7.86315 532.267 -54.7282 546.774 -134.897 462.687Z",
    fill: "#B22134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_208",
    x: -268.217,
    y: 0.319565,
    width: 536.303,
    height: 637.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 54.5,
    result: "effect1_foregroundBlur_8_208"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDesktopLeftEllipse);
export default __webpack_public_path__ + "static/media/RR-desktopLeftEllipse.b25d2bd35d084f6bf2703b2398e412e0.svg";
export { ForwardRef as ReactComponent };